import React, { FC, useRef, useEffect, CSSProperties } from 'react';
import { animate } from './utils';

export interface AnimateHeightProps {
	/**
	 * transition-duration
	 */
	duration?: number | 'auto';
	/**
	 * transition-timing-function
	 */
	timingFunction?: string;
	height?: number | 'auto';
	/**
	 * disable transition
	 */
	animateDisabled?: boolean;
}

const AnimateHeight: FC<AnimateHeightProps> = ({ children, ...props }) => {
	const initialStyleRef = useRef<Partial<CSSProperties>>({ height: props.height, overflowY: 'hidden' });
	const propsRef = useRef<Partial<AnimateHeightProps>>(props);
	const animateRef = useRef<HTMLDivElement>(null);

	propsRef.current = props;

	useEffect(
		() => () => {
			if (animateRef.current) {
				animate(
					animateRef.current,
					props.height!,
					propsRef.current.height!,
					propsRef.current.duration!,
					propsRef.current.timingFunction!,
					propsRef.current.animateDisabled!
				);
			}
		},
		[props.height]
	);

	return (
		<div
			ref={animateRef}
			style={initialStyleRef.current}
		>
			{children}
		</div>
	);
};

AnimateHeight.defaultProps = {
	duration: 'auto',
	timingFunction: 'ease-out',
	height: 'auto',
	animateDisabled: false,
};

export default AnimateHeight;
